var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content-wrapper p-0"},[(_vm.preloader)?_c('app-overlay-loader'):_vm._e(),_vm._v(" "),_c('app-employee-latest',{attrs:{"user":_vm.userInfo,"timeline-states":_vm.timelineStates}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }